import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import path from '../../../assets/images/svgImages.svg';

import styles from './rating-tw-styles';

const spritePath = typeof path === 'string' ? path : path?.src || '';

export default class SecondaryRating extends React.PureComponent {
  static propTypes = {
    rating: PropTypes.number,
    className: PropTypes.string,
    totalReviews: PropTypes.number,
    tabIndex: PropTypes.number,
  };

  static defaultProps = {
    rating: 0,
    className: '',
    totalReviews: 0,
    tabIndex: 0,
  };

  render() {
    const { rating, className, totalReviews, tabIndex } = this.props;
    let qualityAverRating = rating;
    let qualityPercentage = ((qualityAverRating / 5) * 100).toFixed(2);
    var qualityDivStyle = {
      width: qualityPercentage + '%',
    };
    const reviewCount = Number.isFinite(totalReviews) ? totalReviews : 0;
    let reviewLabel = '';
    if (reviewCount === 1) {
      reviewLabel = '1 avaliação';
    } else if (reviewCount === 0) {
      reviewLabel = '0 avaliações';
    } else {
      reviewLabel = `${reviewCount} avaliações`;
    }
    // Only render tabIndex if it's not -1 (to prevent carousel from making it focusable)
    const tabIndexProps = tabIndex !== -1 ? { tabIndex } : {};
    return (
      <div
        className={classNames(styles.ratingMainDiv, className)}
        {...tabIndexProps}
        role="img"
        aria-label={`${qualityAverRating} de 5 estrelas${reviewCount > 0 ? `, ${reviewLabel}` : ''}`}
      >
        <span className={styles.ratingWrapper}>
          <span className={styles.ratingSpan}>
            <svg className={classNames(styles.emptyStar)} aria-hidden="true">
              <use xlinkHref={`${spritePath}#empty_star`} />
            </svg>
            <span style={qualityDivStyle} className={styles.ratingImg}>
              <svg className={classNames(styles.completeStar)} aria-hidden="true">
                <use xlinkHref={`${spritePath}#stars`} />
              </svg>
            </span>
          </span>
        </span>
      </div>
    );
  }
}